import { render, staticRenderFns } from "./PolicyScores.vue?vue&type=template&id=3ef1feca"
import script from "./PolicyScores.vue?vue&type=script&lang=js"
export * from "./PolicyScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports